import React from "react";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRupeeSign } from "@fortawesome/free-solid-svg-icons";
import {
  primaryShade1,
  primaryShade3,
  grey,
  red,
  white
} from "../styles/color";
const styles = theme => ({
  media: {
    height: 0,
    paddingTop: "56.25%" // 16:9
  },
  actions: {
    display: "flex"
  },
  expand: {
    transform: "rotate(0deg)",
    marginLeft: "auto",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest
    })
  },
  expandOpen: {
    transform: "rotate(0deg)"
  },
  avatar: {
    backgroundColor: red
  }
});
class SingleDealPayment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
      months: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ]
    };
  }
  handleExpandClick = () => {
    this.setState(state => ({ expanded: !state.expanded }));
  };
  getDateValue = dateValue => {
    let recievedDateType = typeof dateValue;
    let currentDate =
      recievedDateType === "object"
        ? dateValue.toDate()
        : moment(dateValue).toDate();
    let date = currentDate.getDate();
    let month = this.state.months[currentDate.getMonth()];
    let year = currentDate
      .getYear()
      .toString()
      .substr(-2);
    let dateMonthYear = date + " " + month + " " + year;
    return dateMonthYear;
  };
  render() {
    const { singleDeal, payments } = this.props;
    return (
      <div style={{ height: "60vh", maxHeight: "60 vh", overflow: "scroll" }}>
        {payments.map(tdata =>
          tdata.dealId === singleDeal.id ? (
            <div
              style={{
                width: "94%",
                display: "flex",
                justifyContent: "space-around",
                fontSize: "0.8em",
                margin: "0px 0px 10px 10px",
                borderBottom: "1px solid grey",
                textAlign: "center"
              }}
            >
              <span>{this.getDateValue(tdata.date)}</span>
              <span style={{ color: grey }}>
                {tdata.paymentMethod
                  ? `Payment/${tdata.paymentMethod}`
                  : `${tdata.transporter}/${tdata.vehicleNumber}`}
              </span>
              <span>
                {tdata.quantity ? (
                  `${tdata.quantity} Ton`
                ) : (
                  <span>
                    <FontAwesomeIcon icon={faRupeeSign} size={".60x"} />
                    {tdata.amount}
                  </span>
                )}
              </span>
            </div>
          ) : null
        )}
        <div
          style={{
            display: "flex",
            justifyContent: "space-around",
            borderRadius: "10px",
            marginTop: "10px",
            padding: "10px",
            alignItems: "center"
          }}
        >
          <div>
            <span style={{ textDecoration: "underline" }}>Total</span>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              borderRadius: "10px",
              backgroundColor: primaryShade3
            }}
          >
            <span style={{ padding: "5px" }}>PAID</span>
            <hr style={{ height: "20px" }} />
            <span style={{ padding: "5px" }}>
              &#8377;
              {singleDeal.paidAmount ? singleDeal.paidAmount : 0}
            </span>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              borderRadius: "10px",
              backgroundColor: primaryShade3
            }}
          >
            <span style={{ padding: "5px" }}>PENDING</span>
            <hr style={{ height: "20px" }} />
            <span style={{ padding: "5px" }}>
              &#8377;
              {singleDeal.pendingAmount ? singleDeal.pendingAmount : 0}
            </span>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            alignItem: "center",
            justifyContent: "center"
          }}
        >
          <Button
            variant="contained"
            onClick={e => {
              e.preventDefault();
              this.props.history.push(
                `/deals/${this.props.match.params.dealId}/addDealPayment`
              );
            }}
            style={{
              backgroundColor: primaryShade1,
              borderRadius: "12px"
            }}
          >
            <span style={{ color: white }}>Add Deal Payment</span>
          </Button>
        </div>
      </div>
    );
  }
}

export default withRouter(withStyles(styles)(SingleDealPayment));
